module.exports = __webpack_public_path__ + "static/media/tower-3d.5924816c.png";